import { Stack, StackProps } from '@mui/system';
import { Types } from '@scorenco/core';

import { getEventTeams } from '../utils/eventGuards';

type EventScoreProps = StackProps & {
  event?: Types.Competitions_Event_Detail;
  isAway?: boolean;
};

export const EventScore = ({ event, isAway, ...rest }: EventScoreProps) => {
  const teamIndex = isAway ? 1 : 0;
  const teams = getEventTeams(event?.teams);
  const score = teams[teamIndex]?.score;
  const isWinner =
    event?.status === 'finish' &&
    (teams[teamIndex]?.score ?? 0) > (teams[(teamIndex + 1) % 2]?.score ?? 0);

  if (typeof score !== 'number') {
    return null;
  }

  return (
    <Stack
      sx={{
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '0.25rem',
        textAlign: 'center',
        backgroundColor: 'background.default',
        width: '3rem',
        height: '4rem',
        fontSize: '2rem',
        margin: '0 0.5rem',
        color: 'primary.main',
        ...(isWinner && {
          backgroundColor: 'secondary.main',
          color: 'secondary.contrastText',
        }),
        ...((score || 0) >= 100 && {
          fontSize: '1rem',
        }),
      }}
      // css={[
      //   isLive && style.scoreIsLive,
      // ]}
      {...rest}
    >
      {score}
    </Stack>
  );
};
